import React from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import styles from './styles.less';

const { TextArea: AntTextArea } = Input;
const propsByVersion = {
  default: {
    className: styles.default,
  },
};

const TextArea = ({ version, className, ...rest }) => {
  const { className: propsClassName = '', ...props } = propsByVersion[version];
  return <AntTextArea {...props} className={`${propsClassName} ${className}`} {...rest} />;
};

TextArea.propTypes = {
  version: PropTypes.oneOf(['default']),
  className: PropTypes.string,
};

TextArea.defaultProps = {
  version: 'default',
  className: '',
};

export default TextArea;
